import Api from "../../api/api-helper";
import ApiModel from "./ApiModel";

export default class BoothTemplate extends ApiModel {
  static async fetch(id) {
    const apiboothTemplate = await Api.getInstance().boothTemplateById(id);
    return new BoothTemplate(apiboothTemplate);
  }
}
